import * as d3 from 'd3';

export interface PopulationGridOptions {
  container: HTMLElement;
  values: readonly number[]; // length = cols * rows
  cols?: number;
  rows?: number;
}

export interface PopulationGridHandle {
  element: SVGSVGElement;
  highlight(indices: readonly number[]): void;
  destroy(): void;
}

export function createPopulationGrid(opts: PopulationGridOptions): PopulationGridHandle {
  const cols = opts.cols ?? 100;
  const rows = opts.rows ?? Math.ceil(opts.values.length / cols);
  const cellSize = 4;
  const width = cols * cellSize;
  const height = rows * cellSize;

  const svg = d3
    .create('svg')
    .attr('viewBox', `0 0 ${width} ${height}`)
    .attr('class', 'pop-grid')
    .node()!;
  opts.container.appendChild(svg);

  const sample = opts.values.slice(0, 1000);
  const colour = d3
    .scaleSequential(d3.interpolateBlues)
    .domain([Math.min(...sample), Math.max(...sample)]);

  const root = d3.select(svg).append('g');
  root
    .selectAll('rect.pop-cell')
    .data(opts.values)
    .join('rect')
    .attr('class', 'pop-cell')
    .attr('x', (_d, i) => (i % cols) * cellSize)
    .attr('y', (_d, i) => Math.floor(i / cols) * cellSize)
    .attr('width', cellSize)
    .attr('height', cellSize)
    .attr('fill', (d) => colour(d));

  return {
    element: svg,
    highlight(indices) {
      root
        .selectAll<SVGRectElement, number>('rect.pop-cell')
        .attr('stroke', null)
        .attr('stroke-width', null);
      const set = new Set(indices);
      root
        .selectAll<SVGRectElement, number>('rect.pop-cell')
        .filter((_d, i) => set.has(i))
        .attr('stroke', 'currentColor')
        .attr('stroke-width', 1);
    },
    destroy() {
      svg.remove();
    },
  };
}
